import cx from 'classnames'
import { Spinner } from '@/components/Spinner'
import { match } from '@/utils/pattern-match-util'
import styles from './ContentLoading.module.css'

interface ContentLoadingProps {
  /**
   * How much room the placeholder takes: `base` holds a page open, `compact`
   * a dialog, `section` a card or pane, and `inline` shows only a small spinner.
   */
  size?: 'base' | 'compact' | 'section' | 'inline'
  label?: string
}

/**
 * Shown in place of content that is loading.
 */
export function ContentLoading({ size = 'base', label }: ContentLoadingProps) {
  return (
    <div
      className={cx(
        styles.root,
        match(size, {
          base: styles.base,
          compact: styles.compact,
          section: styles.section,
          inline: undefined,
        }),
      )}
    >
      <Spinner size={size === 'inline' ? 20 : undefined} />
      {label && <div className={styles.label}>{label}</div>}
    </div>
  )
}
